interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ToastEntry {
  id: number;
  message: string;
  action?: ToastAction;
}

let entries: ToastEntry[] = [];
let nextId = 0;
const listeners = new Set<() => void>();

function publish() {
  for (const listener of listeners) listener();
}

export function subscribeToToasts(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getToasts() {
  return entries;
}

function pushToast(message: string, options: { action?: ToastAction } = {}) {
  const id = ++nextId;
  entries = [...entries, { id, message, action: options.action }];
  publish();
  return id;
}

function dismissToast(id?: number) {
  entries = id === undefined ? [] : entries.filter((entry) => entry.id !== id);
  publish();
}

export const toast = Object.assign(pushToast, { dismiss: dismissToast });
